import { Network } from "../../.."
import store from "../../../../store"
import { Person } from "../profile"

class ProviderAttributes {
	constructor(attributes) {
		Object.assign(this, attributes)
	}
}

class Provider extends ProviderAttributes {
	static async getAll({}) {
		const { data: providerData } = await Network.AxiosWrapperV2.get({
			url: "provider"
		})
		const providers = new Map()
		providerData.forEach((d) => {
			providers.set(d.id, new Provider(d))
		})
		return providers
	}

	static async getOne({ params }) {
		const { data: providerData } = await Network.AxiosWrapperV2.get({
			url: `provider/${params.id}`
		})
		return new Provider(providerData)
	}

	static async createOne({ payload }) {
		const { data: providerData } = await Network.AxiosWrapperV2.post({
			data: payload,
			url: `provider`
		})
		return new Provider(providerData)
	}

	async update({ data }) {
		try {
			const { data: providerData } = await Network.AxiosWrapperV2.post({
				url: `provider/${this.id}`
			})
			store.setNotification("notification", true, {
				msg: "Successfully updated provider."
			})
			return new Provider(providerData)
		} catch (err) {
			console.error(err)
		}
	}

	async delete() {
		try {
			const { data: providerData } = await Network.AxiosWrapperV2.send({
				...this.links.delete
			})
			store.setNotification("notification", true, {
				msg: "Successfully deleted provider."
			})
			return true
		} catch (err) {
			console.error(err)
		}
		return false
	}
}

export default Provider
